import { ForwardedRef, forwardRef } from 'react';
import { Breakpoint } from '@mui/material';
import { isMobileOnly } from 'react-device-detect';
import MobileMyTerritoriesContent from './mobile/MobileMyTerritoriesContent';
import DesktopMyTerritoriesContent from './desktop/DesktopMyTerritoriesContent';

interface Props {
    size: Breakpoint;
}

export interface MyTerritoriesRef {
    refreshAssignments: () => void;
}

const MyTerritoriesContent = forwardRef<MyTerritoriesRef, Props>((props: Props, ref: ForwardedRef<MyTerritoriesRef>) => {
    if (isMobileOnly) {
        return <MobileMyTerritoriesContent ref={ref} />
    } else {
        return <DesktopMyTerritoriesContent size={props.size} ref={ref} />
    }
});

export default MyTerritoriesContent;